import { Component, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { FacilityProfileDetails } from 'src/app/locums/models/facility-profile-details.model';
import { LocumsJobService } from 'src/app/locums/services/locums-job.service';
import { JobDetails } from '../../../models/job-details.model';
import { jobDetailsLoaded } from '../../store/selectors/job-details.selectors';
import { LocumsUtility } from 'src/app/locums/locums-utility';
import { ExternalJobDisplayInputDto } from 'src/app/shared/models/external-job-display-input.dto';

@UntilDestroy()
@Component({
    selector: 'nova-locums-recruiter-facility',
    templateUrl: './locums-recruiter-facility.component.html',
    styleUrls: ['./locums-recruiter-facility.component.scss']
})
export class LocumsRecruiterFacilityComponent implements OnInit {
    @Input() jobId: number;
    @Input() displayConfigData: ExternalJobDisplayInputDto;

    facilityProfileDetails: FacilityProfileDetails;
    job: JobDetails;
    traumaLevel: string;
    showMap = false;

    readonly changeDetector$: Subject<void> = new Subject<void>();

    constructor(private readonly locumsJobService: LocumsJobService, private readonly store: Store) {}

    ngOnInit(): void {
        this.getLocumsFacilityProfileDetails(this.jobId);

        this.store
            .select(jobDetailsLoaded)
            .pipe(untilDestroyed(this))
            .subscribe((e) => {
                if (e.success) {
                    this.job = e.job;
                }
            });
    }

    getLocumsFacilityProfileDetails(jobId: number): void {
        if (!jobId) {
            return;
        }

        this.locumsJobService
            .getFacilityProfileDetails(jobId)
            .pipe(untilDestroyed(this))
            .subscribe((facilityProfileDetails: FacilityProfileDetails) => {
                this.facilityProfileDetails = facilityProfileDetails;
                this.traumaLevel = LocumsUtility.getTraumaLevel(
                    facilityProfileDetails?.isTraumaFacility,
                    facilityProfileDetails?.hasAdultTrauma,
                    facilityProfileDetails?.hasPedsTrauma,
                    facilityProfileDetails?.isTraumaLevel1,
                    facilityProfileDetails?.isTraumaLevel2,
                    facilityProfileDetails?.isTraumaLevel3,
                    facilityProfileDetails?.isTraumaLevel4
                );
            });
    }
}
